export const environment = {
  production: false,
  apiUrl: 'https://5t699qhi65.execute-api.sa-east-1.amazonaws.com/dev/v1',
  apiViaCep: 'https://viacep.com.br/ws/',
  apiImg: 'http://localhost:8000/avatar/',
  titleSite: 'Secretárias',
  secret: 'qwertyuiopasdfghjklzxcvbnm123456',
  amazonMaps: {
    apiKey:
      'v1.public.eyJqdGkiOiI5NTQ4MDFjZS00ODU3LTQ1NjItODU5ZS0wYjVlNGQzYWIyODgifY9gwrIayGKSa7_pE9GkUG_lXyfNwrdVaDpygU8dG5v3aRWoBgTa6K9SSFTW46AjLfaKj9jRXsXgoeA4kUodhp0U35FZjk_9rj6DjC3N6NN7UiQXgYoIRr9VykqFwg1UR03uci9xqpsKmc8KS82oaRVnjWtbRdLGaA1zENLqid3LWQu0jzgd3DnEzSb42TFAPHUIQrikTuBM6lO2rFFYnKP14tZp6R82hY6AkLSxAK9QJa5OWtCuWjxwJoHjD_I4-jgxDi0Gp28l-eV4UCcvauodslnXMNvqvTvM4lv0K09qnTToekudxKw2PWsAp8LfUa2jI_rghP6XfBV8vJNSIc0.ZTA0NDFlODYtNGY5Mi00NWU4LTk1MDgtMmY4YmViYWFhYjUz',
    mapName: 'secretarias-map-open',
    region: 'sa-east-1',
  },
  userPoolClientId: '4u9dlrdi4jqm3dsiad6ss20fr6',
  userPoolId: 'sa-east-1_5QuXVXgiJ',
  oAuthDomain: 'possoagendar.auth.sa-east-1.amazoncognito.com',
  oAuthRedirectSignIn: [
    'http://localhost:4200/google-login',
    'https://secretariavaledosaofrancisco.com/google-login',
    'https://possoagendar.auth.sa-east-1.amazoncognito.com/oauth2/idpresponse',
  ],
  oAuthRedirectSignOut: [],
};

import 'zone.js/dist/zone-error';
